import React from "react";
import styled from "styled-components";
import errorImage from "../assets/error-robot.png";
import { SPECIAL_ERRORS } from "../config/error";
import { NavLink } from "react-router-dom";

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	height: 100%;
	width: 100%;
`;

const Image = styled.img`
	margin:15% 0 0 0;
	width:100%;
	max-height:300px;
	max-width:300px;
`;

const Header = styled.div`
	margin:0 0 0 -5px;
	text-align: center;
	font-weight: 600;
	font-size: min(7vw, 28px);
	color: #FFCC00;
	width: 100%;
`;

const Content = styled.div<any>`
	margin: 2rem 0 0 0;
	text-align: ${props => props.alignText || "left"};
	font-weight: 500;
	font-size: min(3vw, 14px);
	line-height: 20px;
	color: #fff;
	width: 75%;
	font-size:16px;
`;

const Link = styled(NavLink)`
	margin: 2rem 0 0 0;
	text-align: center;
	font-weight: 600;
	font-size: min(3.7vw, 18px);
	color: #fff;
	width: 75%;
	text-decoration:underline;
	text-underline-offset: 2px;
`;

const ErrorComponent = (props:any) => {

	const { code } = props;

	let message = "", header = "", image = "", link = "", linkText = "", alignText = "";

	switch(code) {
		
		case SPECIAL_ERRORS.NETWORK_ERROR :
			header = "Network issue.";
			message = "Seems like you have internet issue, check your internet and refresh your app.";
			image = "https://res.cloudinary.com/xook/image/upload/v1707737269/app.xook.ai/no_network-01-01_sbkaqs.png";
			break;

		case SPECIAL_ERRORS.GET_STATIC_DATA_FAILED:
			header = "XOOK ID NOT FOUND";
			message = "It seems like the xook Id that you have entered is wrong. Kindly reenter the kiosk Id that’s written on the left top panel of the kiosk.";
			image = "https://res.cloudinary.com/xook/image/upload/v1707737269/app.xook.ai/oops-01_jdi4zp.png";
			link = "/"
			linkText = "Checkout another Kiosk"
			break;

		// case SPECIAL_ERRORS.GET_DYNAMIC_DATA_FAILED :
		// 	header = "OOPS!";
		// 	message = "Oops, due to some technical issue we are not serving now. Come back after sometime to try again.";
		// 	image = "https://res.cloudinary.com/xook/image/upload/v1707737269/app.xook.ai/Technical_issue-01_yrzspy.png";
		// 	break;

		case SPECIAL_ERRORS.RESTAURANT_UNDER_MAINTENANCE :
			header = "UNDER MAINTENANCE";
			message = "To ensure healthy serving of kiosk and provide undisturbed and excellent experience the kiosk is under planned maintenance. Please come back after some time to order.";
			image = "https://res.cloudinary.com/xook/image/upload/v1707737269/app.xook.ai/app_maintainance-01_s7ztog.png";
			break;
		case SPECIAL_ERRORS.GET_DYNAMIC_DATA_FAILED :
		case SPECIAL_ERRORS.RESTAURANT_MENU_NOT_ACTIVE_TODAY :
		case SPECIAL_ERRORS.RESTAURANT_CLOSED :
		
			header = "KIOSK CLOSED";
			message = "We are not serving now. Please come back later.";
			image = "https://res.cloudinary.com/xook/image/upload/v1707737269/app.xook.ai/oops-01_jdi4zp.png";
			break;
		default :
			header = "OOPS!";
			message = "Something went wrong!";
			alignText = "center";
			image = "https://res.cloudinary.com/xook/image/upload/v1707737269/app.xook.ai/oops-01_jdi4zp.png";
			break;
	}

	return (
		<Wrapper>
			<Image src={image || errorImage} />
			<Header>{header}</Header>
			<Content alignText={alignText} >{message}</Content>
			{
				link ? <Link to={link} >{linkText}</Link> : ""
			}
		</Wrapper>
	);
};

export default ErrorComponent;
